'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recordSocialNetworkShare = exports.recordAttributionAnalytics = exports.trackUpcomingCatalogClick = exports.trackTrendingItemClick = exports.trackFeaturedCategoryClick = exports.trackFeaturedCatalogClick = exports.trackHeroClick = exports.trackACNClick = exports.trackAdUnitClick = exports.trackClick = exports.recordAnalyticsForWonItemsPageView = exports.recordAnalyticsForTerminologyPageView = exports.recordAnalyticsForTermsAndConditionsPageView = exports.recordAnalyticsForSearchItemsPageView = exports.recordAnalyticsForSellerPageView = exports.recordAnalyticsForSellerTestimonialsPageView = exports.recordAnalyticsForSellerDirectoryPageView = exports.recordAnalyticsForSavedSearchesPageView = exports.recordAnalyticsForSavedItemsPageView = exports.recordAnalyticsForPRServicesPageView = exports.recordAnalyticsForPrivacyPageView = exports.recordAnalyticsForPasswordResetPageView = exports.recordAnalyticsForNearMePageView = exports.recordAnalyticsForMyBidsPageView = exports.recordAnalyticsForMyAuctionsPageView = exports.recordAnalyticsForMobilePageView = exports.recordAnalyticsForMessagesPageView = exports.recordAnalyticsForItemPageView = exports.recordAnalyticsForIntellectualPropertyPageView = exports.recordAnalyticsForIdentify = exports.recordAnalyticsForHowItWorksPageView = exports.recordAnalyticsForHomePageView = exports.recordAnalyticsForFollowedSellersPageView = exports.recordAnalyticsForFeaturesPageView = exports.recordAnalyticsForCheckoutPageView = exports.recordAnalyticsForCheckoutConfirmationPageView = exports.recordAnalyticsForCookiePolicyPageView = exports.recordAnalyticsForConsignmentsPageView = exports.recordAnalyticsForCategoryLandingPageView = exports.recordAnalyticsForCatalogPageView = exports.recordAnalyticsForBidConsolePageView = exports.recordAnalyticsForAuctionResultsPageView = exports.recordAnalyticsForAddCreditCardPageView = exports.recordAnalyticsForAccountSettingsPageView = exports.recordAnalyticsForAboutUsPageView = exports.saveFullStorySessionUrl = exports.getRetractedAbsenteeBidAnalytics = exports.getPlacedAbsenteeBidAnalytics = exports.getRequestedAuctionRegistrationAnalytics = exports.getLoginAnalytics = exports.getSetPasswordAnalytics = exports.getRegisterAccountAnalytics = exports.getCompleteAccountAnalytics = exports.getUnfollowSellerAnalytics = exports.getFollowSellerAnalytics = exports.getUnfollowSearchAnalytics = exports.getFollowSearchAnalytics = exports.getUnsaveItemAnalytics = exports.getSaveItemAnalytics = exports.getAttributionData = exports.getFullStorySessionUrl = exports.SOCIAL_NETWORK_SHARE = exports.SET_PASSWORD = exports.UNSAVE_ITEM = exports.UNFOLLOW_SELLER = exports.UNFOLLOW_SEARCH = exports.SAVE_ITEM = exports.RETRACTED_ABSENTEE_BID = exports.REQUESTED_AUCTION_REGISTRATION = exports.REGISTER_ACCOUNT = exports.PLACED_ABSENTEE_BID = exports.FOLLOW_SELLER = exports.FOLLOW_SEARCH = exports.COMPLETE_ACCOUNT = exports.TRACK_SOCIAL_NETWORK_SHARE = exports.TRACK_PAGEVIEW = exports.TRACK_CLICK = exports.TRACK_ATTRIBUTION_DATA = exports.SAVE_FULLSTORY_SESSION_URL = exports.IDENTIFY_ANALYTICS = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = require('./user');

var _urls = require('../../utils/urls');

var _route = require('./route');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _reduxSegment = require('redux-segment');

var _biddingInfo = require('./biddingInfo');

var _catalog = require('./catalog');

var _catalogRegistration = require('./catalogRegistration');

var _categoryGrabber = require('../../utils/categoryGrabber');

var _item = require('./item');

var _itemFacets = require('./itemFacets');

var _seller = require('./seller');

var _whiteLabel = require('./whiteLabel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KNOWN_SEARCH_ENGINES = ['.msn.', '.search.com', 'about.com', 'adsensecustomsearchads.com', 'alice.', 'alltheweb.com', 'altavista.com', 'ask.com', 'avg.com', 'babylon.com', 'baidu.', 'biglobe.', 'bing.', 'centrum.cz', 'cnn.com/search', 'daum.net', 'delta-search.com', 'discretesearch.com', 'duckduckgo.com', 'easydialsearch.com', 'ekolay.net', 'eniro.se', 'haosou.com', 'kvasir.no', 'lycos.', 'mamma.com', 'mynet.com', 'myprivatesearch.com', 'mysearchdial.com', 'najdi.', 'naver.com', 'onet.pl', 'onetcenter.', 'ozu.es', 'pchome.com', 'query.searchdconvertnow.com', 'rakuten.', 'rambler.ru', 'search.aol', 'search.avira.net', 'search.bt.com', 'search.centurylink.com', 'search.colonymt.com', 'search.earthlink.net', 'search.excite.com', 'search.frontier.com', 'search.media.telstra.com', 'search.mediacomcable.com', 'search.monstercrawler.com', 'search.myway.com', 'search.pch.com', 'search.smt.docomo', 'search.socialdownloadr.com', 'search.twcc.com', 'search.us.com', 'search.xfinity.com', 'search.yahoo.com', 'searchall.com', 'searchassist.verizon.com', 'searchguide.windstream.net', 'searchlock.com', 'searchprivacy.co', 'searcht.sosodesktop.com', 'searchthis.com', 'securesearch.co', 'sesam.no', 'seznam.cz', 'so.com', 'sogou.com', 'startsiden.no', 'szukacz.pl', 'terra.com', 'thesmartsearch.net', 'utorrent.inspsearch.com', 'virgilio.it', 'voila.fr', 'w.goo.ne.jp', 'w.google.', 'w.yahoo.com', 'wp.pl', 'www.delta-search.com', 'yam.com', 'yandex.', 'yoursearch.me', 'zdsearch.com'];
var KNOWN_SOCIAL_NETWORKS = ['pinterest.', 'twitter.', '/t.co', 'facebook.', 'yuku.', 'netvibes.', 'blogspot.', 'houzz.', 'polyvore.', 'youtube.', 'vk.com', 'paper.li', 'reddit.', 'buzzfeed.', 'plus.google.', 'plus.url.google', 'ravelry', 'wikia.', 'wordpress.', 'blog.goo.ne', 'linkedin.', 'groups.google.', '.ning.', 'stackexchange.', 'stumbleupon.', 'tumblr.', 'typepad.', 'answers.yahoo.'];
var IGNORED_REFERRERS = ['liveauctioneers.', 'optimizely.', 'atlassian.', 'localhost', 'rainforestqa.'];

/* ACTION TYPES */
// const SET_ANONYMOUS_ID = 'SET_ANONYMOUS_ID';
var IDENTIFY_ANALYTICS = exports.IDENTIFY_ANALYTICS = 'IDENTIFY_ANALYTICS';
var SAVE_FULLSTORY_SESSION_URL = exports.SAVE_FULLSTORY_SESSION_URL = 'SAVE_FULLSTORY_SESSION_URL';
var TRACK_ATTRIBUTION_DATA = exports.TRACK_ATTRIBUTION_DATA = 'TRACK_ATTRIBUTION_DATA';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';
var TRACK_PAGEVIEW = exports.TRACK_PAGEVIEW = 'TRACK_PAGEVIEW';
var TRACK_SOCIAL_NETWORK_SHARE = exports.TRACK_SOCIAL_NETWORK_SHARE = 'TRACK_SOCIAL_NETWORK_SHARE';

/* ANALYTIC TYPES */
var COMPLETE_ACCOUNT = exports.COMPLETE_ACCOUNT = 'Completed Profile';
var FOLLOW_SEARCH = exports.FOLLOW_SEARCH = 'Followed Search';
var FOLLOW_SELLER = exports.FOLLOW_SELLER = 'Followed Auctioneer';
var PLACED_ABSENTEE_BID = exports.PLACED_ABSENTEE_BID = 'Placed Absentee Bid';
var REGISTER_ACCOUNT = exports.REGISTER_ACCOUNT = 'Registered Account';
var REQUESTED_AUCTION_REGISTRATION = exports.REQUESTED_AUCTION_REGISTRATION = 'Requested Auction Registration';
var RETRACTED_ABSENTEE_BID = exports.RETRACTED_ABSENTEE_BID = 'Retracted abstentee bid';
var SAVE_ITEM = exports.SAVE_ITEM = 'Saved Item';
var UNFOLLOW_SEARCH = exports.UNFOLLOW_SEARCH = 'Unfollowed Search';
var UNFOLLOW_SELLER = exports.UNFOLLOW_SELLER = 'Unfollowed Auctioneer';
var UNSAVE_ITEM = exports.UNSAVE_ITEM = 'Unsaved Item';
var SET_PASSWORD = exports.SET_PASSWORD = 'Set Password';
var SOCIAL_NETWORK_SHARE = exports.SOCIAL_NETWORK_SHARE = 'Social Network Share';

// reducer
var DEFAULT_STATE = {
    anonymousId: '',
    attributionData: {
        bidderId: 0,
        campaign: 'Placeholder campaign Data',
        content: 'Placeholder content Data',
        keyword: 'Placeholder keyword Data',
        medium: 'Placeholder medium Data',
        source: 'Placeholder source Data',
        touchDate: 0
    },
    fullStorySessionUrl: '',
    referrer: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SAVE_FULLSTORY_SESSION_URL:
            return (0, _extends3.default)({}, state, {
                fullStorySessionUrl: action.payload
            });
        case TRACK_ATTRIBUTION_DATA:
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.analytics;
};

var getReferrer = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.referrer;
});
var getFullStorySessionUrl = exports.getFullStorySessionUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.fullStorySessionUrl;
});

var getSailthru = function getSailthru() {
    return typeof window !== 'undefined' ? window.Sailthru : function () {
        return false;
    };
};

var getTouchDate = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.touchDate;
});

var searchList = function searchList(haystack, needle) {
    var ret = -1;
    haystack.forEach(function (value) {
        if (needle.toLowerCase().includes(value)) {
            ret = needle;
        }
    });
    return ret;
};

var getAttributionData = exports.getAttributionData = function getAttributionData(state) {
    var _getCurrentUrl = (0, _route.getCurrentUrl)(state),
        search = _getCurrentUrl.search;

    var rawReferrer = getReferrer(state);
    var referrer = (0, _urls.separateURL)(rawReferrer);
    var bidderId = (0, _user.getBidderId)(state);
    var touchDate = getTouchDate(state);

    var attributionData = {
        bidderId: bidderId,
        campaign: '',
        content: '',
        keyword: '',
        medium: '',
        source: '',
        touchDate: touchDate
    };

    var engineName = searchList(KNOWN_SEARCH_ENGINES, rawReferrer);
    var networkName = searchList(KNOWN_SOCIAL_NETWORKS, rawReferrer);
    var referrerName = searchList(IGNORED_REFERRERS, rawReferrer);
    var queryObject = (0, _urls.getParamsFromQueryString)(search);
    if (queryObject.gclid) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'adwords',
            content: 'adwords',
            keyword: queryObject.gclid,
            medium: 'cpc',
            source: 'google'
        });
    } else if (queryObject.gclsrc) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'DoubleClick',
            content: 'DoubleClick',
            keyword: queryObject.gclsrc || '',
            medium: 'cpc',
            source: 'google'
        });
    } else if (queryObject.campaignsource) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: queryObject.campaignname || '',
            content: queryObject.campaigncontent || '',
            keyword: queryObject.campaignkeyword || '',
            medium: queryObject.campaignmedium || '',
            source: queryObject.campaignsource || ''
        });
    } else if (queryObject.utm_source) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: queryObject.utm_campaign || '',
            content: queryObject.utm_content || '',
            keyword: queryObject.utm_term || '',
            medium: queryObject.utm_medium || '',
            source: queryObject.utm_source || ''
        });
    } else if (engineName !== -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'organic',
            source: referrer.host
        });
    } else if (networkName !== -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'social',
            source: referrer.host
        });
    } else if (referrer.host !== '' && referrerName === -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'referral',
            source: referrer.host
        });
    } else {
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'direct',
            source: 'direct'
        });
    }
    return attributionData;
};

var getItemPrice = function getItemPrice(salePrice, leadingBid) {
    return salePrice || leadingBid;
};

var mapCategoryNames = function mapCategoryNames(facets) {
    var newFacets = (0, _cloneDeep2.default)(facets);
    for (var prop in facets) {
        if (Object.prototype.hasOwnProperty.call(newFacets, prop)) {
            newFacets[prop] = newFacets[prop].map(function (facet) {
                var facetLevel = (0, _categoryGrabber.getCategoryLevel)(facet);
                if (facetLevel.categoryName) {
                    return facetLevel.categoryName;
                }
                return facet;
            });
        }
    }
    return newFacets;
};

var getItemAnalytics = function getItemAnalytics(state, itemId, event) {
    var item = (0, _item.getItem)(state, itemId);
    var itemFacets = (0, _itemFacets.getItemFacets)(state, itemId);
    var facets = mapCategoryNames(itemFacets);
    var catalog = (0, _catalog.getCatalog)(state, item.catalogId);

    var _getBiddingInfo = (0, _biddingInfo.getBiddingInfo)(state, itemId),
        leadingBid = _getBiddingInfo.leadingBid;

    var salePrice = item.salePrice,
        sellerId = item.sellerId,
        title = item.title;
    var buyersPremium = catalog.buyersPremium,
        catalogId = catalog.catalogId,
        catalogStatus = catalog.catalogStatus;
    var _facets$categories = facets.categories,
        categories = _facets$categories === undefined ? 'n/a' : _facets$categories,
        _facets$creators = facets.creators,
        creators = _facets$creators === undefined ? 'n/a' : _facets$creators,
        _facets$materialsTech = facets.materialsTechniques,
        materialsTechniques = _facets$materialsTech === undefined ? 'n/a' : _facets$materialsTech,
        _facets$origins = facets.origins,
        origins = _facets$origins === undefined ? 'n/a' : _facets$origins,
        _facets$stylePeriods = facets.stylePeriods,
        stylePeriods = _facets$stylePeriods === undefined ? 'n/a' : _facets$stylePeriods;


    var price = getItemPrice(salePrice, leadingBid);

    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: event,
                properties: {
                    buyersPremium: buyersPremium,
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    categories: categories,
                    creators: creators,
                    houseId: sellerId,
                    itemId: itemId,
                    materialsTechniques: materialsTechniques,
                    origins: origins,
                    price: price,
                    stylePeriods: stylePeriods,
                    title: title
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
    return formatAnalytics;
};

var getSaveItemAnalytics = exports.getSaveItemAnalytics = function getSaveItemAnalytics(state, itemId) {
    return getItemAnalytics(state, itemId, SAVE_ITEM);
};

var getUnsaveItemAnalytics = exports.getUnsaveItemAnalytics = function getUnsaveItemAnalytics(state, itemId) {
    return getItemAnalytics(state, itemId, UNSAVE_ITEM);
};

var getSellerAnalytics = function getSellerAnalytics(sellerId, event) {
    return {
        analytics: {
            eventPayload: {
                event: event,
                properties: {
                    houseId: sellerId
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getFollowSearchAnalytics = exports.getFollowSearchAnalytics = function getFollowSearchAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: FOLLOW_SEARCH
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getUnfollowSearchAnalytics = exports.getUnfollowSearchAnalytics = function getUnfollowSearchAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: UNFOLLOW_SEARCH
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getFollowSellerAnalytics = exports.getFollowSellerAnalytics = function getFollowSellerAnalytics(sellerId) {
    return getSellerAnalytics(sellerId, FOLLOW_SELLER);
};

var getUnfollowSellerAnalytics = exports.getUnfollowSellerAnalytics = function getUnfollowSellerAnalytics(sellerId) {
    return getSellerAnalytics(sellerId, UNFOLLOW_SELLER);
};

var getCompleteAccountAnalytics = exports.getCompleteAccountAnalytics = function getCompleteAccountAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: COMPLETE_ACCOUNT
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};

var registerAnalytics = function registerAnalytics(state, bidderId, attributionData, event) {
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    return {
        analytics: [{
            eventPayload: {
                event: event,
                properties: {
                    attribution_bidderId: bidderId,
                    attribution_campaign: attributionData.campaign,
                    attribution_content: attributionData.content,
                    attribution_keyword: attributionData.keyword,
                    attribution_medium: attributionData.medium,
                    attribution_source: attributionData.source,
                    attribution_touchdate: attributionData.touchDate,
                    whiteLabel: whiteLabel
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }]
    };
};

var getRegisterAccountAnalytics = exports.getRegisterAccountAnalytics = function getRegisterAccountAnalytics(state, bidderId, attributionData) {
    return registerAnalytics(state, bidderId, attributionData, REGISTER_ACCOUNT);
};

var getSetPasswordAnalytics = exports.getSetPasswordAnalytics = function getSetPasswordAnalytics(state, bidderId, attributionData) {
    return registerAnalytics(state, bidderId, attributionData, SET_PASSWORD);
};

var getLoginAnalytics = exports.getLoginAnalytics = function getLoginAnalytics(loginData) {
    return {
        analytics: {
            eventPayload: {
                traits: {
                    annualNms: loginData.annualNMS,
                    createdAt: loginData.bidder.createdDate,
                    creditCardValidated: loginData.bidder.creditCardValidated,
                    email: loginData.bidder.email,
                    firstName: loginData.bidder.firstName,
                    lastName: loginData.bidder.lastName,
                    profileComplete: loginData.bidder.profileComplete
                },
                userId: loginData.bidder.bidderId
            },
            eventType: _reduxSegment.EventTypes.identify
        }
    };
};

var getRequestedAuctionRegistrationAnalytics = exports.getRequestedAuctionRegistrationAnalytics = function getRequestedAuctionRegistrationAnalytics(state, catalogId) {
    // TODO: this is gross and needs to be refactored once we have catalogs in the
    // store, but for now it will work
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);

    var _ref = (0, _catalog.getCatalog)(state, catalogId) || {},
        catalogStatus = _ref.catalogStatus,
        sellerId = _ref.sellerId;

    var auctionAnalytics = {
        analytics: {
            eventPayload: {
                event: REQUESTED_AUCTION_REGISTRATION,
                properties: {
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    sellerId: sellerId,
                    whiteLabel: whiteLabel
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
    return auctionAnalytics;
};

var getPlacedAbsenteeBidAnalytics = exports.getPlacedAbsenteeBidAnalytics = function getPlacedAbsenteeBidAnalytics(state, itemId, bidAmount) {
    // TODO: we need to decide what the proper definition of 'bidCount' is and then implement
    var _getItem = (0, _item.getItem)(state, itemId),
        catalogId = _getItem.catalogId,
        salePrice = _getItem.salePrice,
        sellerId = _getItem.sellerId,
        title = _getItem.title;

    var _getCatalog = (0, _catalog.getCatalog)(state, catalogId),
        buyersPremium = _getCatalog.buyersPremium,
        catalogStatus = _getCatalog.catalogStatus,
        currency = _getCatalog.currency;

    var _getBiddingInfo2 = (0, _biddingInfo.getBiddingInfo)(state, itemId),
        leadingBid = _getBiddingInfo2.leadingBid;

    var approvedForAuction = (0, _catalogRegistration.getCatalogRegistration)(state, catalogId).approved;
    var userData = (0, _user.getUserData)(state);
    var bidderId = userData.bidderId;
    var price = getItemPrice(salePrice, leadingBid);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    // const bidCount = 1;
    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: PLACED_ABSENTEE_BID,
                properties: {
                    approvedForAuction: approvedForAuction,
                    // bidCount,
                    biddingStatus: 'absentee',
                    buyersPremium: buyersPremium,
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    currency: currency,
                    houseId: sellerId,
                    itemId: itemId,
                    orderId: itemId + '-' + bidderId,
                    products: [{
                        id: itemId,
                        name: title,
                        price: price,
                        quantity: 1
                    }],
                    total: bidAmount,
                    value: bidAmount,
                    whiteLabel: whiteLabel
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };

    return formatAnalytics;
};

var getRetractedAbsenteeBidAnalytics = exports.getRetractedAbsenteeBidAnalytics = function getRetractedAbsenteeBidAnalytics(state, itemId, retractionReason, retractionExplanation) {
    var userData = (0, _user.getUserData)(state);
    var bidderId = userData.bidderId;

    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: RETRACTED_ABSENTEE_BID,
                properties: {
                    bidderId: bidderId,
                    itemId: itemId,
                    retractionExplanation: retractionExplanation,
                    retractionReason: retractionReason
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };

    return formatAnalytics;
};

/* ACTION CREATORS */
var sailthruTrack = function sailthruTrack(url) {
    var sailthru = getSailthru();
    if (sailthru) {
        var path = (0, _urls.separateURL)(url).path ? (0, _urls.separateURL)(url).path : url;
        var finalURL = 'https://www.liveauctioneers.com' + path;
        try {
            sailthru.track('pageview', {
                url: finalURL
            });
        } catch (e) {
            // commenting out this error because its pointless
            // console.log('Edge thinks this method wants an object, but it\'s wrong!');
        }
    }
};

var saveFullStorySessionUrl = exports.saveFullStorySessionUrl = function saveFullStorySessionUrl(sessionUrl) {
    return {
        payload: sessionUrl,
        type: SAVE_FULLSTORY_SESSION_URL
    };
};

var trackPageView = function trackPageView(pageType, props) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, currentUrl;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            currentUrl = (0, _route.getCurrentUrlFromState)(state);


                            sailthruTrack(currentUrl);
                            return _context.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: (0, _extends3.default)({
                                                pageType: pageType,
                                                url: currentUrl
                                            }, props)
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: TRACK_PAGEVIEW
                            }));

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAboutUsPageView = exports.recordAnalyticsForAboutUsPageView = function recordAnalyticsForAboutUsPageView() {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', dispatch(trackPageView('about us')));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAccountSettingsPageView = exports.recordAnalyticsForAccountSettingsPageView = function recordAnalyticsForAccountSettingsPageView() {
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt('return', dispatch(trackPageView('account settings')));

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAddCreditCardPageView = exports.recordAnalyticsForAddCreditCardPageView = function recordAnalyticsForAddCreditCardPageView() {
    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            return _context4.abrupt('return', dispatch(trackPageView('add credit card')));

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAuctionResultsPageView = exports.recordAnalyticsForAuctionResultsPageView = function recordAnalyticsForAuctionResultsPageView() {
    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt('return', dispatch(trackPageView('auction results')));

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, undefined);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForBidConsolePageView = exports.recordAnalyticsForBidConsolePageView = function recordAnalyticsForBidConsolePageView(catalogId) {
    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
            var state, catalog, catalogStatus, saleStartTs, sellerId, title, pathname;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            state = getState();
                            catalog = (0, _catalog.getCatalog)(state, catalogId);
                            catalogStatus = catalog.catalogStatus, saleStartTs = catalog.saleStartTs, sellerId = catalog.sellerId, title = catalog.title;
                            pathname = (0, _urls.getCatalogUrl)(catalogId, title);
                            return _context6.abrupt('return', dispatch(trackPageView('bidding console', {
                                catalogId: catalogId,
                                catalogStatus: catalogStatus,
                                houseId: sellerId,
                                path: pathname,
                                saleStartTs: saleStartTs,
                                title: title
                            })));

                        case 5:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, undefined);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCatalogPageView = exports.recordAnalyticsForCatalogPageView = function recordAnalyticsForCatalogPageView(catalogId) {
    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch, getState) {
            var state, catalog, catalogStatus, saleStartTs, sellerId, title, pathname;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            state = getState();
                            catalog = (0, _catalog.getCatalog)(state, catalogId);
                            catalogStatus = catalog.catalogStatus, saleStartTs = catalog.saleStartTs, sellerId = catalog.sellerId, title = catalog.title;
                            pathname = (0, _urls.getCatalogUrl)(catalogId, title);
                            return _context7.abrupt('return', dispatch(trackPageView('catalog', {
                                catalogId: catalogId,
                                catalogStatus: catalogStatus,
                                houseId: sellerId,
                                path: pathname,
                                saleStartTs: saleStartTs,
                                title: title
                            })));

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, undefined);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCategoryLandingPageView = exports.recordAnalyticsForCategoryLandingPageView = function recordAnalyticsForCategoryLandingPageView() {
    return function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch, getState) {
            var state, _getCurrentUrl2, pathname;

            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            state = getState();
                            _getCurrentUrl2 = (0, _route.getCurrentUrl)(state), pathname = _getCurrentUrl2.pathname;
                            return _context8.abrupt('return', dispatch(trackPageView('category', { path: pathname })));

                        case 3:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, undefined);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForConsignmentsPageView = exports.recordAnalyticsForConsignmentsPageView = function recordAnalyticsForConsignmentsPageView() {
    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            return _context9.abrupt('return', dispatch(trackPageView('consignments')));

                        case 1:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, undefined);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCookiePolicyPageView = exports.recordAnalyticsForCookiePolicyPageView = function recordAnalyticsForCookiePolicyPageView() {
    return function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            return _context10.abrupt('return', dispatch(trackPageView('cookie policy')));

                        case 1:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, undefined);
        }));

        return function (_x21, _x22) {
            return _ref11.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCheckoutConfirmationPageView = exports.recordAnalyticsForCheckoutConfirmationPageView = function recordAnalyticsForCheckoutConfirmationPageView() {
    return function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            return _context11.abrupt('return', dispatch(trackPageView('checkout confirmation')));

                        case 1:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, undefined);
        }));

        return function (_x23, _x24) {
            return _ref12.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCheckoutPageView = exports.recordAnalyticsForCheckoutPageView = function recordAnalyticsForCheckoutPageView() {
    return function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            return _context12.abrupt('return', dispatch(trackPageView('checkout page')));

                        case 1:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, undefined);
        }));

        return function (_x25, _x26) {
            return _ref13.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForFeaturesPageView = exports.recordAnalyticsForFeaturesPageView = function recordAnalyticsForFeaturesPageView() {
    return function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            return _context13.abrupt('return', dispatch(trackPageView('features')));

                        case 1:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, undefined);
        }));

        return function (_x27, _x28) {
            return _ref14.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForFollowedSellersPageView = exports.recordAnalyticsForFollowedSellersPageView = function recordAnalyticsForFollowedSellersPageView() {
    return function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            return _context14.abrupt('return', dispatch(trackPageView('followed sellers')));

                        case 1:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, undefined);
        }));

        return function (_x29, _x30) {
            return _ref15.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForHomePageView = exports.recordAnalyticsForHomePageView = function recordAnalyticsForHomePageView() {
    return function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            return _context15.abrupt('return', dispatch(trackPageView('home')));

                        case 1:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, undefined);
        }));

        return function (_x31, _x32) {
            return _ref16.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForHowItWorksPageView = exports.recordAnalyticsForHowItWorksPageView = function recordAnalyticsForHowItWorksPageView() {
    return function () {
        var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            return _context16.abrupt('return', dispatch(trackPageView('how it works')));

                        case 1:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, undefined);
        }));

        return function (_x33, _x34) {
            return _ref17.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForIdentify = exports.recordAnalyticsForIdentify = function recordAnalyticsForIdentify(bidder) {
    return {
        meta: getLoginAnalytics(bidder),
        payload: {},
        type: IDENTIFY_ANALYTICS
    };
};

var recordAnalyticsForIntellectualPropertyPageView = exports.recordAnalyticsForIntellectualPropertyPageView = function recordAnalyticsForIntellectualPropertyPageView() {
    return function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            return _context17.abrupt('return', dispatch(trackPageView('intellectual property')));

                        case 1:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, undefined);
        }));

        return function (_x35, _x36) {
            return _ref18.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForItemPageView = exports.recordAnalyticsForItemPageView = function recordAnalyticsForItemPageView(itemId) {
    return function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(dispatch, getState) {
            var state, item, catalog, biddingInfo, facets, salePrice, sellerId, title, buyersPremium, catalogId, catalogStatus, categories, creators, materialsTechniques, origins, stylePeriods, leadingBid, pathname, pageType;
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            state = getState();
                            item = (0, _item.getItem)(state, itemId);
                            catalog = (0, _catalog.getCatalog)(state, item.catalogId);
                            biddingInfo = (0, _biddingInfo.getBiddingInfo)(state, itemId);
                            facets = (0, _itemFacets.getItemFacets)(state, itemId);
                            salePrice = item.salePrice, sellerId = item.sellerId, title = item.title;
                            buyersPremium = catalog.buyersPremium, catalogId = catalog.catalogId, catalogStatus = catalog.catalogStatus;
                            categories = facets.categories, creators = facets.creators, materialsTechniques = facets.materialsTechniques, origins = facets.origins, stylePeriods = facets.stylePeriods;
                            leadingBid = biddingInfo.leadingBid;
                            pathname = (0, _urls.getItemUrl)(itemId, title);
                            pageType = catalogStatus === 'done' ? 'sold item' : 'item';
                            return _context18.abrupt('return', dispatch(trackPageView(pageType, {
                                buyersPremium: buyersPremium,
                                catalogId: catalogId,
                                catalogStatus: catalogStatus,
                                categories: categories,
                                creators: creators,
                                houseId: sellerId,
                                itemId: itemId,
                                materialsTechniques: materialsTechniques,
                                origins: origins,
                                path: pathname,
                                salePrice: salePrice || leadingBid,
                                stylePeriods: stylePeriods,
                                title: title
                            })));

                        case 12:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, undefined);
        }));

        return function (_x37, _x38) {
            return _ref19.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMessagesPageView = exports.recordAnalyticsForMessagesPageView = function recordAnalyticsForMessagesPageView() {
    return function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            return _context19.abrupt('return', dispatch(trackPageView('messages')));

                        case 1:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, undefined);
        }));

        return function (_x39, _x40) {
            return _ref20.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMobilePageView = exports.recordAnalyticsForMobilePageView = function recordAnalyticsForMobilePageView() {
    return function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            return _context20.abrupt('return', dispatch(trackPageView('mobile', { path: '/mobile' })));

                        case 1:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, undefined);
        }));

        return function (_x41, _x42) {
            return _ref21.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMyAuctionsPageView = exports.recordAnalyticsForMyAuctionsPageView = function recordAnalyticsForMyAuctionsPageView() {
    return function () {
        var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(dispatch, getState) {
            var pathname;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            pathname = (0, _urls.getMyAuctionsUrl)();
                            return _context21.abrupt('return', dispatch(trackPageView('my auctions', { path: pathname })));

                        case 2:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, undefined);
        }));

        return function (_x43, _x44) {
            return _ref22.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMyBidsPageView = exports.recordAnalyticsForMyBidsPageView = function recordAnalyticsForMyBidsPageView() {
    return function () {
        var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(dispatch, getState) {
            var pathname;
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            pathname = (0, _urls.getMyBidsUrl)();
                            return _context22.abrupt('return', dispatch(trackPageView('my bids', { path: pathname })));

                        case 2:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, undefined);
        }));

        return function (_x45, _x46) {
            return _ref23.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForNearMePageView = exports.recordAnalyticsForNearMePageView = function recordAnalyticsForNearMePageView() {
    return function () {
        var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            return _context23.abrupt('return', dispatch(trackPageView('near me')));

                        case 1:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, undefined);
        }));

        return function (_x47, _x48) {
            return _ref24.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPasswordResetPageView = exports.recordAnalyticsForPasswordResetPageView = function recordAnalyticsForPasswordResetPageView() {
    return function () {
        var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            return _context24.abrupt('return', dispatch(trackPageView('password reset')));

                        case 1:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, undefined);
        }));

        return function (_x49, _x50) {
            return _ref25.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPrivacyPageView = exports.recordAnalyticsForPrivacyPageView = function recordAnalyticsForPrivacyPageView() {
    return function () {
        var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            return _context25.abrupt('return', dispatch(trackPageView('privacy')));

                        case 1:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, undefined);
        }));

        return function (_x51, _x52) {
            return _ref26.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPRServicesPageView = exports.recordAnalyticsForPRServicesPageView = function recordAnalyticsForPRServicesPageView() {
    return function () {
        var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            return _context26.abrupt('return', dispatch(trackPageView('pr services')));

                        case 1:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, undefined);
        }));

        return function (_x53, _x54) {
            return _ref27.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSavedItemsPageView = exports.recordAnalyticsForSavedItemsPageView = function recordAnalyticsForSavedItemsPageView() {
    return function () {
        var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(dispatch, getState) {
            var pathname;
            return _regenerator2.default.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            pathname = (0, _urls.getSavedItemsUrl)();
                            return _context27.abrupt('return', dispatch(trackPageView('saved items', { path: pathname })));

                        case 2:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, undefined);
        }));

        return function (_x55, _x56) {
            return _ref28.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSavedSearchesPageView = exports.recordAnalyticsForSavedSearchesPageView = function recordAnalyticsForSavedSearchesPageView(pageType) {
    return function () {
        var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            return _context28.abrupt('return', dispatch(trackPageView(pageType)));

                        case 1:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, undefined);
        }));

        return function (_x57, _x58) {
            return _ref29.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerDirectoryPageView = exports.recordAnalyticsForSellerDirectoryPageView = function recordAnalyticsForSellerDirectoryPageView() {
    return function () {
        var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            return _context29.abrupt('return', dispatch(trackPageView('directory')));

                        case 1:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, undefined);
        }));

        return function (_x59, _x60) {
            return _ref30.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerTestimonialsPageView = exports.recordAnalyticsForSellerTestimonialsPageView = function recordAnalyticsForSellerTestimonialsPageView() {
    return function () {
        var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            return _context30.abrupt('return', dispatch(trackPageView('testimonials')));

                        case 1:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, undefined);
        }));

        return function (_x61, _x62) {
            return _ref31.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerPageView = exports.recordAnalyticsForSellerPageView = function recordAnalyticsForSellerPageView(sellerId) {
    return function () {
        var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(dispatch, getState) {
            var state, seller, name, pathname;
            return _regenerator2.default.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            state = getState();
                            seller = (0, _seller.getSeller)(state, sellerId);
                            name = seller.name;
                            pathname = (0, _urls.getSellerUrl)(sellerId, name);
                            return _context31.abrupt('return', dispatch(trackPageView('auctioneer', {
                                houseId: sellerId,
                                name: name,
                                path: pathname
                            })));

                        case 5:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, undefined);
        }));

        return function (_x63, _x64) {
            return _ref32.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSearchItemsPageView = exports.recordAnalyticsForSearchItemsPageView = function recordAnalyticsForSearchItemsPageView() {
    return function () {
        var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(dispatch, getState) {
            var state, _getCurrentUrl3, pathname;

            return _regenerator2.default.wrap(function _callee32$(_context32) {
                while (1) {
                    switch (_context32.prev = _context32.next) {
                        case 0:
                            state = getState();
                            _getCurrentUrl3 = (0, _route.getCurrentUrl)(state), pathname = _getCurrentUrl3.pathname;
                            return _context32.abrupt('return', dispatch(trackPageView('search', { path: pathname })));

                        case 3:
                        case 'end':
                            return _context32.stop();
                    }
                }
            }, _callee32, undefined);
        }));

        return function (_x65, _x66) {
            return _ref33.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForTermsAndConditionsPageView = exports.recordAnalyticsForTermsAndConditionsPageView = function recordAnalyticsForTermsAndConditionsPageView() {
    return function () {
        var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee33$(_context33) {
                while (1) {
                    switch (_context33.prev = _context33.next) {
                        case 0:
                            return _context33.abrupt('return', dispatch(trackPageView('terms and conditions')));

                        case 1:
                        case 'end':
                            return _context33.stop();
                    }
                }
            }, _callee33, undefined);
        }));

        return function (_x67, _x68) {
            return _ref34.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForTerminologyPageView = exports.recordAnalyticsForTerminologyPageView = function recordAnalyticsForTerminologyPageView() {
    return function () {
        var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee34$(_context34) {
                while (1) {
                    switch (_context34.prev = _context34.next) {
                        case 0:
                            return _context34.abrupt('return', dispatch(trackPageView('terminology')));

                        case 1:
                        case 'end':
                            return _context34.stop();
                    }
                }
            }, _callee34, undefined);
        }));

        return function (_x69, _x70) {
            return _ref35.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForWonItemsPageView = exports.recordAnalyticsForWonItemsPageView = function recordAnalyticsForWonItemsPageView() {
    return function () {
        var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee35$(_context35) {
                while (1) {
                    switch (_context35.prev = _context35.next) {
                        case 0:
                            dispatch(trackPageView('won items'));

                        case 1:
                        case 'end':
                            return _context35.stop();
                    }
                }
            }, _callee35, undefined);
        }));

        return function (_x71, _x72) {
            return _ref36.apply(this, arguments);
        };
    }();
};

var getGAEventAnalytics = function getGAEventAnalytics(action, category, label) {
    return {
        analytics: {
            eventPayload: {
                event: action,
                properties: {
                    action: action,
                    category: category,
                    label: label
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};

var trackClick = exports.trackClick = function trackClick(action, label) {
    return function () {
        var _ref37 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee36(dispatch, getState) {
            var analytics;
            return _regenerator2.default.wrap(function _callee36$(_context36) {
                while (1) {
                    switch (_context36.prev = _context36.next) {
                        case 0:
                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context36.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 2:
                        case 'end':
                            return _context36.stop();
                    }
                }
            }, _callee36, undefined);
        }));

        return function (_x73, _x74) {
            return _ref37.apply(this, arguments);
        };
    }();
};

var trackAdUnitClick = exports.trackAdUnitClick = function trackAdUnitClick(_ref38) {
    var adUnitId = _ref38.adUnitId,
        catalogId = _ref38.catalogId,
        sellerId = _ref38.sellerId;
    return function () {
        var _ref39 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee37(dispatch, getState) {
            var state, bidderId, action, label, analytics;
            return _regenerator2.default.wrap(function _callee37$(_context37) {
                while (1) {
                    switch (_context37.prev = _context37.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked ' + (catalogId ? 'Catalog' : 'Consignmet') + ' Ad Unit';
                            label = 'sideBanner-' + adUnitId + '-' + (catalogId || sellerId);

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context37.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context37.stop();
                    }
                }
            }, _callee37, undefined);
        }));

        return function (_x75, _x76) {
            return _ref39.apply(this, arguments);
        };
    }();
};

var trackACNClick = exports.trackACNClick = function trackACNClick(label) {
    return function () {
        var _ref40 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee38(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee38$(_context38) {
                while (1) {
                    switch (_context38.prev = _context38.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage ACN Module';
                            labelToUse = '' + label;

                            if (bidderId !== -1) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context38.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context38.stop();
                    }
                }
            }, _callee38, undefined);
        }));

        return function (_x77, _x78) {
            return _ref40.apply(this, arguments);
        };
    }();
};

var trackHeroClick = exports.trackHeroClick = function trackHeroClick(label) {
    return function () {
        var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee39(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee39$(_context39) {
                while (1) {
                    switch (_context39.prev = _context39.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Hero Banner Module';
                            labelToUse = '' + label;

                            if (bidderId !== -1) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context39.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context39.stop();
                    }
                }
            }, _callee39, undefined);
        }));

        return function (_x79, _x80) {
            return _ref41.apply(this, arguments);
        };
    }();
};

var trackFeaturedCatalogClick = exports.trackFeaturedCatalogClick = function trackFeaturedCatalogClick(catalogId) {
    return function () {
        var _ref42 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee40(dispatch, getState) {
            var state, _getCatalog2, sellerId, bidderId, action, label, analytics;

            return _regenerator2.default.wrap(function _callee40$(_context40) {
                while (1) {
                    switch (_context40.prev = _context40.next) {
                        case 0:
                            state = getState();
                            _getCatalog2 = (0, _catalog.getCatalog)(state, catalogId), sellerId = _getCatalog2.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Featured Auctions Module';
                            label = 'featured-' + catalogId + '-' + sellerId;

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context40.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 8:
                        case 'end':
                            return _context40.stop();
                    }
                }
            }, _callee40, undefined);
        }));

        return function (_x81, _x82) {
            return _ref42.apply(this, arguments);
        };
    }();
};

var trackFeaturedCategoryClick = exports.trackFeaturedCategoryClick = function trackFeaturedCategoryClick(label) {
    return function () {
        var _ref43 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee41(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee41$(_context41) {
                while (1) {
                    switch (_context41.prev = _context41.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Featured Categories Module';
                            labelToUse = '' + label;

                            if (bidderId !== -1) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context41.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context41.stop();
                    }
                }
            }, _callee41, undefined);
        }));

        return function (_x83, _x84) {
            return _ref43.apply(this, arguments);
        };
    }();
};

var trackTrendingItemClick = exports.trackTrendingItemClick = function trackTrendingItemClick(itemId) {
    return function () {
        var _ref44 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee42(dispatch, getState) {
            var state, _getItem2, catalogId, _getCatalog3, sellerId, bidderId, action, label, analytics;

            return _regenerator2.default.wrap(function _callee42$(_context42) {
                while (1) {
                    switch (_context42.prev = _context42.next) {
                        case 0:
                            state = getState();
                            _getItem2 = (0, _item.getItem)(state, itemId), catalogId = _getItem2.catalogId;
                            _getCatalog3 = (0, _catalog.getCatalog)(state, catalogId), sellerId = _getCatalog3.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Trending Items Module';
                            label = 'Trending-Items-' + itemId + '-' + sellerId;

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context42.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 9:
                        case 'end':
                            return _context42.stop();
                    }
                }
            }, _callee42, undefined);
        }));

        return function (_x85, _x86) {
            return _ref44.apply(this, arguments);
        };
    }();
};

var trackUpcomingCatalogClick = exports.trackUpcomingCatalogClick = function trackUpcomingCatalogClick(catalogId) {
    return function () {
        var _ref45 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee43(dispatch, getState) {
            var state, _getCatalog4, catalogStatus, sellerId, bidderId, status, action, label, analytics;

            return _regenerator2.default.wrap(function _callee43$(_context43) {
                while (1) {
                    switch (_context43.prev = _context43.next) {
                        case 0:
                            state = getState();
                            _getCatalog4 = (0, _catalog.getCatalog)(state, catalogId), catalogStatus = _getCatalog4.catalogStatus, sellerId = _getCatalog4.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            status = catalogStatus === 'online' ? 'upcoming' : catalogStatus;
                            action = 'Clicked Homepage Live and Upcoming Auctions Module';
                            label = status + '-' + catalogId + '-' + sellerId;

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context43.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 9:
                        case 'end':
                            return _context43.stop();
                    }
                }
            }, _callee43, undefined);
        }));

        return function (_x87, _x88) {
            return _ref45.apply(this, arguments);
        };
    }();
};

var recordAttributionAnalytics = exports.recordAttributionAnalytics = function recordAttributionAnalytics(data) {
    return {
        meta: {
            analytics: {
                eventPayload: {
                    properties: {
                        attribution_bidderId: data.bidderId,
                        attribution_campaign: data.campaign,
                        attribution_content: data.content,
                        attribution_keyword: data.keyword,
                        attribution_medium: data.medium,
                        attribution_source: data.source,
                        attribution_touchdate: data.touchDate,
                        nonInteraction: 1,
                        should_store_in_db: true
                    }
                },
                eventType: _reduxSegment.EventTypes.track
            }
        },
        payload: {},
        type: TRACK_ATTRIBUTION_DATA
    };
};

var recordSocialNetworkShare = exports.recordSocialNetworkShare = function recordSocialNetworkShare(network, itemUrl) {
    return function () {
        var _ref46 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee44(dispatch, getState) {
            var state, bidderId;
            return _regenerator2.default.wrap(function _callee44$(_context44) {
                while (1) {
                    switch (_context44.prev = _context44.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);

                            dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            event: SOCIAL_NETWORK_SHARE,
                                            properties: {
                                                bidderId: bidderId,
                                                itemUrl: itemUrl,
                                                network: network
                                            }
                                        },
                                        eventType: _reduxSegment.EventTypes.track
                                    }
                                },
                                payload: {},
                                type: TRACK_SOCIAL_NETWORK_SHARE
                            });

                        case 3:
                        case 'end':
                            return _context44.stop();
                    }
                }
            }, _callee44, undefined);
        }));

        return function (_x89, _x90) {
            return _ref46.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/analytics.js
// module id = yxCd
// module chunks = 60